export default "__VITE_ASSET__CzGqKDjx__"